import { Popup } from '@CS/components/Popups';
import CSS from './NetworkError.module.css';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import Content from './content';

type NetworkErrorProps = {
  onRetry?: () => void;
};

export const NetworkError = ({ onRetry }: NetworkErrorProps) => {
  const { title, text, button } = useTranslation(Content);

  return (
    <Popup fullscreen hideClose>
      <div className={CSS.errorContent}>
        <h2>{title}</h2>
        <span>{text}</span>
        <Button text={button} onClick={onRetry} />
      </div>
    </Popup>
  );
};
